module.exports = __webpack_public_path__ + "img/horse-portrait-painting-2.206f0385.png";